import React, { useState, useEffect, useRef } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import "./SideDrawer.css"; // Import external CSS

const SideDrawer = ({
    isOpen,
    onClose,
    fileName,
    sizeInGB,
    fileUrl,
    instructionUrl,
    handleBrowserDownload
}) => {
    const [copyState, setCopyState] = useState("Copy");
    const drawerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (drawerRef.current && !drawerRef.current.contains(event.target)) {
                onClose(); // Close the drawer when clicked outside
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen, onClose]);

    const handleClipboardCopy = (url) => {
        navigator.clipboard.writeText(url).then(() => {
            setCopyState("Copied");
            setTimeout(() => setCopyState("Copy"), 2000);
        }).catch((err) => {
            console.error("Failed to copy URL: ", err);
        });
    };

    return (
        <div className={`side-drawer ${isOpen ? "open" : ""}`} ref={drawerRef}>
            <div className="drawer-header">
                <h3>Download Options</h3>
                <button className="close-button" onClick={onClose}>✕</button>
            </div>
            <p className="file-info">
                The file <strong>{fileName}</strong> exceeds 10 GB ({sizeInGB.toFixed(2)} GB). Browser downloads may be
                slow. For faster performance, consider using <a href="https://azure.microsoft.com/en-us/products/storage/storage-explorer" target="_blank" rel="noopener noreferrer"><strong>Azure Storage Explorer</strong> <FaExternalLinkAlt className="external-link-icon" /></a>.
            </p>
            <button className="download-btn" onClick={handleBrowserDownload}>
                Download via Browser
            </button>

            <div className="copy-url">
                <div className="instruction-link">
                    <FaExternalLinkAlt className="instruction-icon" />
                    <a href={instructionUrl} target="_blank" rel="noopener noreferrer">
                        Instructions for Azure Storage Explorer Downloads
                    </a>
                </div>
                
                <div className="storage-explorer-section">
                    <p className="url-label">Azure Storage Explorer SAS URL:</p>
                    <div className="url-container" title={fileUrl}>
                        <div className="url-box">
                            <span className="url-text">{fileUrl}</span>
                            <button 
                                className={`copy-btn ${copyState === "Copied" ? "copied" : ""}`} 
                                onClick={() => handleClipboardCopy(fileUrl)}
                            >
                                {copyState}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SideDrawer;
